import { useInfiniteQuery } from "@tanstack/react-query";

import { api } from "@contexts";
import type { Request } from "@interfaces";

export interface RequestSearchResponse {
  items: Request[];
  nextCursor?: string;
  hasMore: boolean;
}

interface UseRequestsSearchParams {
  searchTerm: string;
  status: "active" | "pending" | "all";
  pageSize?: number;
}

export const useRequestsSearch = ({
  searchTerm,
  status,
  pageSize = 20,
}: UseRequestsSearchParams) => {
  return useInfiniteQuery<RequestSearchResponse>({
    queryKey: ["requests-search", searchTerm, status, pageSize],
    queryFn: ({ pageParam }) =>
      api<RequestSearchResponse>({
        url: `/requests/search`,
        method: "GET",
        params: {
          searchTerm: searchTerm || undefined,
          cursor: pageParam || undefined,
          limit: pageSize,
          status,
        },
      }),
    initialPageParam: undefined,
    getNextPageParam: (lastPage) =>
      lastPage.hasMore && lastPage.nextCursor ? lastPage.nextCursor : undefined,
  });
};
